import Box from "@mui/material/Box";
import { memo } from "react";

import { ProspectCellValue } from "../types";

const getDisplayValue = (value: ProspectCellValue) => {
  return value === null || value === undefined || value === ""
    ? "-"
    : String(value);
};

const renderProspectValue = (value: ProspectCellValue) => {
  const displayValue = getDisplayValue(value);

  return (
    <Box
      component="span"
      sx={{
        display: "-webkit-box",
        overflow: "hidden",
        overflowWrap: "anywhere",
        textOverflow: "ellipsis",
        WebkitBoxOrient: "vertical",
        WebkitLineClamp: 3,
        whiteSpace: "normal",
        width: "100%",
      }}
      title={displayValue}
    >
      {displayValue}
    </Box>
  );
};

const renderSubmissionTime = (value: ProspectCellValue) => {
  if (typeof value !== "number") {
    return renderProspectValue(value);
  }

  return renderProspectValue(
    new Date(value).toLocaleString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    }),
  );
};

type ProspectCellProps = {
  value: ProspectCellValue;
  scoreMax: number | undefined;
  isSubmissionTime: boolean;
};

const ProspectCell = memo(function ProspectCell({
  value,
  scoreMax,
  isSubmissionTime,
}: ProspectCellProps) {
  if (scoreMax !== undefined && typeof value === "number") {
    return renderProspectValue(`${value} / ${scoreMax}`);
  }

  if (isSubmissionTime) {
    return renderSubmissionTime(value);
  }

  return renderProspectValue(value);
});

export default ProspectCell;
